import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Header {
    constructor(){
        this.header = {
            el: document.querySelector('header'),
            content: document.querySelectorAll('header nav'),
            logo: document.querySelector('header .logo'),
            navbar: document.querySelector('header .navbar'),
            top: document.querySelector('header .top-header'),
        };

        this.menu = {
            logo: document.getElementById('logo-inline'),
        }

        this.footer = document.querySelector('footer');

        this.company = document.getElementById('company');
    }

    init(){
        // if(!Sniff.features.mobile){
            this.clip();
            // this.set();
            // this.animation();
        // }
    }

    clip = () => {
        window.addEventListener('scroll', () => {
            if(window.pageYOffset >= this.header.top.clientHeight){
                // this.header.logo.classList.add('clip');
                // this.header.navbar.classList.add('collapsed');
                // this.header.top.classList.add('collapsed');
                this.header.el.classList.add('collapsed');
            } else {
                // this.header.logo.classList.remove('clip');
                // this.header.navbar.classList.remove('collapsed');
                // this.header.top.classList.remove('collapsed');
                this.header.el.classList.remove('collapsed');

            }
        });
    }

    set = () => {
        // Set using GSAP
    }

    animation = () => {
        // Animate using GSAP
    }
}
